module.exports = __webpack_public_path__ + "static/img/8_northern_japan.b9fddddb.png";